import React from "react";
import ReactDOM from "react-dom/client";
import MainRouter from "./router";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./shared/styles/global.scss";
import reportWebVitals from "./reportWebVitals";
import "react-toastify/dist/ReactToastify.css";
import { isBrowserDefined } from "./shared/services/browserService";

// Import mapbox CSS conditionally for Next.js compatibility
if (typeof window !== "undefined") {
  require("mapbox-gl/dist/mapbox-gl.css");
}

// Only render in browser environment
if (isBrowserDefined()) {
  // Create a React root
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
  );

  // Create a helmet context object
  const helmetContext = {};

  root.render(
    <HelmetProvider context={helmetContext}>
      <BrowserRouter>
        <MainRouter />
      </BrowserRouter>
    </HelmetProvider>,
  );

  reportWebVitals();
}
